// extracted by mini-css-extract-plugin
export default {"info_container":"OrderAgain_info_container__Fv-Tb"};